// extracted by mini-css-extract-plugin
module.exports = {"header":"SupportCenter_style_header__2h95u"};